const config = {
  docmaxlength: null
}

export default config
